import React, { FC, ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Alert, Col, Row } from 'antd'
import Marquee from 'react-fast-marquee'
import NumberWithCommas from '~utils/NumberWithCommas'
import { ApplicationState } from '~store/index'
import ProfileButton from '~components/Elements/ProfileButton'
import Breadcrumb from '~components/Elements/Breadcrumb'
import Emergency from '~components/Elements/Emergency'
import DateTimeNow from '~components/Elements/DateTimeNow'
import useFetchAnnouncer from "~hooks/useFetchAnnouncer"
import moment from 'moment'

interface TitleBarProps {
    title: string | ReactNode
    subTitle?: string | ReactNode
    routes?: any | ReactNode
}

const TitleBar: FC<TitleBarProps> = ({ title, subTitle, routes }) => {
    const [scrollPosition, setScrollPosition] = useState(0)
    const [announcement, setAnnouncement] = useState<string>("")
    const authState = useSelector((state: ApplicationState) => state.auth)
    const username = authState.data.username
    const role = authState.data.user?.role
    const balance = authState.data.user?.balance
    const currency = authState.data.user?.currency ? (authState.data.user?.currency).toUpperCase() : "THB"
    const onScroll = (offset: number) => setScrollPosition(offset)
    const funcSetScroll = () => window.addEventListener('scroll', () => onScroll(window.pageYOffset))

    const { data: dataAnnouncer, isLoading: isLoadingAnnouncer } = useFetchAnnouncer(20000)


    useEffect(() => {
        setAnnouncement("")
        if (dataAnnouncer !== undefined && dataAnnouncer.data.length > 0) {
            const ann = dataAnnouncer.data[0]
            setAnnouncement(`${ann.description} - ${moment(ann.updatedAt).format('DD/MM/YYYY HH:mm:ss')}`)
        }
        return () => {
            setAnnouncement("")
        }
    }, [dataAnnouncer, isLoadingAnnouncer])

    useEffect(() => {
        funcSetScroll()
        return () => {
            onScroll(0);
        };
    }, []) //eslint-disable-line

    return (
        <>
            <div className={'title-bar ' + (scrollPosition > 50 ? 'scrolling' : '')}>
                <h2 className="mb-0 position-relative d-none d-lg-block">
                    {title}
                    {subTitle && (<small className="sub-title">{subTitle}</small>)}
                </h2>
                <div className="d-none d-lg-flex align-items-center ms-auto">
                    <Emergency username={username} />
                    <div className="line-separator"></div>
                    <DateTimeNow />
                    <div className="line-separator"></div>
                    <div className="balance-card d-none d-lg-block">
                        <div className="balance-card-title">Balance</div>
                        <div className="balance-card-value">{NumberWithCommas(balance, 2)} {currency}</div>
                    </div>
                    <div className="line-separator"></div>
                    <ProfileButton className="d-none d-lg-block" username={username} role={role} />
                </div>
            </div>
            <Row gutter={[0, 16]} style={{ marginBottom: 16 }}>
                <Col span={24} xs={{ order: 1 }} lg={{ order: 2 }}>
                    <Alert
                        banner
                        showIcon={false}
                        className="announcement-card"
                        message={<Marquee pauseOnHover gradient={false}>{announcement ? announcement : "MSNSLOT Backoffice - MSNSLOT"}</Marquee>}
                    />
                </Col>

                <Col span={24} xs={{ order: 2 }} lg={{ order: 1 }}>
                    <h2 className="mb-0 position-relative d-lg-none">
                        {title}
                        {subTitle && (<small className="sub-title">{subTitle}</small>)}
                    </h2>
                </Col>

                {routes && (
                    <Col span={24} xs={{ order: 3 }}>
                        <Breadcrumb routes={routes} />
                    </Col>
                )}
            </Row>
        </>
    )
}

export default TitleBar